import { createSlice } from "@reduxjs/toolkit";

const desktopSignupSlice = createSlice({
  name: "desktopSignup",
  initialState: {
    showDesktopSignupModal: false,
    canEscape: true,
    isSignupModalFiredByPageView: false,
  },
  reducers: {
    setShowDesktopSignupModal: (prevState, action) => {
      const state = prevState;
      state.showDesktopSignupModal = action.payload.showDesktopSignupModal;
    },
    setCanEscape: (prevState, action) => {
      const state = prevState;
      state.canEscape = action.payload.canEscape;
    },
    setIsSignupModalFiredByPageView: (prevState, action) => {
      const state = prevState;
      state.isSignupModalFiredByPageView = action.payload.isSignupModalFiredByPageView;
    },
  },
  selectors: {
    showDesktopSignupModalSelector: (state) => state.showDesktopSignupModal,
    canEscapeSelector: (state) => state.canEscape,
    isSignupModalFiredByPageViewSelector: (state) => state.isSignupModalFiredByPageView,
  },
});

export const { setShowDesktopSignupModal, setCanEscape, setIsSignupModalFiredByPageView } = desktopSignupSlice.actions;
export const { showDesktopSignupModalSelector, canEscapeSelector, isSignupModalFiredByPageViewSelector } =
  desktopSignupSlice.selectors;

export default desktopSignupSlice.reducer;
